import React, { useEffect, useState } from "react";

import { FiSettings } from "react-icons/fi";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
function AdddNewindustry() {
  const params = useParams();
  const [language, setLanguage] = useState();

  const [initialVal, setInitialVal] = useState({
    // country: "",
    // nationality: "",
    // is_default: null,
    // is_active: null,
    // language_id: "",

    industry: "",
    is_active: 1,
    // language_id: "",
    is_default: 1,
  });

  const navigate = useNavigate();

  const getLanguageData = async () => {
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/language`
      );
      setLanguage(res.data);
    } catch (error) {
      alert("language data not found");
    }
  };

  const changeHandler = (e) => {
    const clone = { ...initialVal };
    const value = e.target.value;
    const name = e.target.name;
    clone[name] = value;
    setInitialVal(clone);
  };

  const getById = async (id) => {
    const res = await axios.get(
      `https://abarishr.hennainternational.in/api/industry/${params?.id}`
    );
    const clone = { ...res.data };
    setInitialVal(clone);
  };

  useEffect(() => {
    getLanguageData();
    if (params?.id) {
      getById();
    }
  }, []);

  const notify = (updateMassage) => toast(updateMassage);

  const handleAdd = async () => {
    try {
      const res = await axios.post(
        `https://abarishr.hennainternational.in/api/industry/add`,
        initialVal
      );
      notify("Add Successfull");
      setTimeout(() => {
        navigate("/admin/list-industries");
      }, 1000);
    } catch (error) { }
  };

  const updateHandle = async () => {
    try {
      const res = await axios.put(
        `https://abarishr.hennainternational.in/api/industry/update/${params.id}`,
        initialVal
      );
      notify("Update Successfull");
      setTimeout(() => {
        navigate("/admin/list-industries");
      }, 1000);
    } catch (error) { }
  };

  return (
    <>
      <div className="pageTableWrapper">
        <ToastContainer />
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>INDUSTRY FORM</h5>
          </div>
        </div>

        <div className="pageBody">
          <div className="pageTable">
            <form>
              <div className="form-group mb-3">
                <label htmlFor="language_level">
                  <strong>Industry</strong>
                </label>
                <input
                  className="form-control"
                  id="language_level"
                  placeholder="Language Level"
                  dir="ltr"
                  type="text"
                  name="industry"
                  value={initialVal?.industry}
                  onChange={changeHandler}
                />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="is_default">
                  <strong>Is Default?</strong>
                </label>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_default"
                    value={1}
                    checked={initialVal?.is_default == 1}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_default_yes">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_default"
                    value={0}
                    checked={initialVal?.is_default == 0}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_default_no">
                    No
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="is_active">
                  <strong>Is Active?</strong>
                </label>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_active"
                    value={1}
                    checked={initialVal?.is_active == 1}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_active_yes">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_active"
                    value={0}
                    checked={initialVal?.is_active == 0}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_active_no">
                    No
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="pageFooter text-center mt-2">
          <button
            className="btn btn-large btn-primary"
            type="button"
            onClick={params.id ? updateHandle : handleAdd}
          >
            Update <BsFillArrowRightCircleFill />
          </button>
        </div>
      </div>
    </>
  );
}
export default AdddNewindustry;
